import { useEffect, useState } from "react";
import { getCookie } from "helpers";
import { useRouter } from "next/router";

const useContainerWidget = (props) => {
  const { 
    arrayLength = 0, 
    containerName,
    dynamicType = 'default',
    title = '',
  } = props;
  const initialIndexNews = Array.from({ length: arrayLength }, (_, index) => index);
  const [firstRender, setFirstRender] = useState(false);
  const [loading, setLoading] = useState(['abTest','dynamicNews'].includes(dynamicType) ?? false);
  const [indexNews, setIndexNews] = useState(initialIndexNews);
  const router = useRouter();
  
  let initMarfeelTitle = title
  ? `${containerName}-` +
    title
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase()
  : containerName;
  const [marfeelTitle, setMarfeelTitle] = useState(initMarfeelTitle);

  const formatUrlDynamic = (params, paramsDynamic = "") => {
    if (router.query.app === "true" || getCookie("app") === "true") {
      return;
    }
    props?.content?.forEach((element, index) => {
      if(element.url.includes(params) || (paramsDynamic !== "" && element.url.includes(paramsDynamic))) return;
      if (paramsDynamic && index > (arrayLength - 1)) {
        element.url = element.url + paramsDynamic;
      } else {
        element.url = element.url + params;
      }
    });
  }

  useEffect(() => {
    if (props.isPreview) return;
    let newsReads = JSON.parse(localStorage.getItem("news_reads")) || [];
    const isRandomDynamicNews = getCookie("randomDynamicNews");
    if (isRandomDynamicNews === "0" && dynamicType === "abTest") {
      formatUrlDynamic("?fijo");
      setLoading(false);
      return
    };
  const findModuleDynamic = props?.positionProperties && typeof props.positionProperties === 'object'
    ? Object.values(props.positionProperties).find(
        (item) =>
          item.dynamicType === "abTestModule" ||
          item.dynamicType === "dynamicNewsModule"
      )
    : undefined;

    if(
      ((findModuleDynamic?.dynamicType === "abTestModule" || dynamicType === "abTest") && isRandomDynamicNews === "1") ||
      findModuleDynamic?.dynamicType === "dynamicNewsModule" ||       
      dynamicType === "dynamicNews"
    ) {
      if(dynamicType === "abTest") {
        formatUrlDynamic("?dinamico","?dinamico_rotacion");
      }
      setMarfeelTitle(marfeelTitle + "-dynamic");
    }      
    if (newsReads.length > 0 && ['abTest','dynamicNews'].includes(dynamicType)) {
      const contentWithoutNewsReads = props.content
        .map((item, index) =>
          !newsReads.some((newsRead) => newsRead.id === item.lilaNewsID)
            ? index
            : -1
        )
        .filter((index) => index !== -1);
      const contentWithNewsReads = props.content
        .map((item, index) =>
          newsReads.some((newsRead) => newsRead.id === item.lilaNewsID)
            ? index
            : -1
        )
        .filter((index) => index !== -1);
      const contentSorted = [
        ...contentWithoutNewsReads,
        ...contentWithNewsReads,
      ];
      const newContent = contentSorted.slice(0, arrayLength);      
      setIndexNews(newContent);
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
    } else {
      setLoading(false);
    }
  }, [indexNews]);

  return {
    indexNews,
    loading,
    marfeelTitle,
  };
};

export default useContainerWidget;
